import React, { Component } from 'react';
import Assets from '../../../requests/apa/Asset';
import DeviceStorage from '../../DeviceStorage/DeviceStorage';

export default class Marker extends Component  {
    constructor(props) {
        super(props);
        const region = DeviceStorage.getItem("region");
        this.markerImageDefault = Assets.get("LandingClaroTv_Paginador_ImagenPaginadorSinFoco_Paginador_sinfoco", '');
        this.markerImage = Assets.get(`LandingClaroTv_Paginador_ImagenPaginadorSinFoco_Paginador_sinfoco_${region}`, '') || this.markerImageDefault;
        this.markerImageFocusDefault = Assets.get("LandingPageClaroTv_Paginador_ImagenPaginadorConFoco_Paginador_Foco", '');
        this.markerImageFocus = Assets.get(`LandingPageClaroTv_Paginador_ImagenPaginadorConFoco_Paginador_Foco_${region}`,  '') || this.markerImageFocusDefault;
    
        this.state = {
            imageFocusError: false,
            imageError: false,
            focus: false
        }
    }
    
    render() {
        const { onFocus } = this.props;
        const { markerImage, markerImageFocus, markerImageDefault, markerImageFocusDefault } = this;
        const { imageError, imageFocusError, focus } = this.state;

        return (
            <a  
                className={'marker focusable'} 
                href="javascript:void(0)"
                onFocus={() => {
                    onFocus()
                    this.setState({focus: true})
                }}
                onBlur={() => this.setState({focus: false})}
                > 
                <img 
                    className="marker-image" 
                    src={imageError ? markerImageDefault : markerImage}
                    onError={imageError ? () => {} : () => {
                        this.setState({imageError: true})
                    }}
                    style={{display: focus ? "none" : "inline-block"}}
                    />
                <img 
                    className="marker-image" 
                    src={imageFocusError ? markerImageFocusDefault : markerImageFocus}
                    onError={imageFocusError ? () => {} : () => {
                        this.setState({imageFocusError: true})
                    }}
                    style={{display: !focus ? "none" : "inline-block"}}
                    />
            </a>
        )
    }
    
}




// WEBPACK FOOTER //
// ./src/components/LandingPage/components/Marker.jsx